import { mapActions } from 'vuex';

export default {
    methods: {
        async generatePlanogram(params, previewPdf = false) {
            this.toggleLoader({
                name: 'generate-planogram',
                start: true,
            });

            try {
                const response = await axios.post(
                    Laroute.route(
                        'franchise.inventory.planogram.exportAsFile',
                        {
                            type: 'pdf',
                        },
                    ),
                    params,
                    { responseType: 'blob' },
                );
                this.toggleLoader({
                    name: 'generate-planogram',
                    start: false,
                });

                return this.download(response, previewPdf);
            } catch (error) {
                //do something
            }
        },

        download(response, isForPreview = false) {
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: 'pdf' }),
            );
            const link = document.createElement('a');
            const contentDisposition = response.headers['content-disposition'];
            let fileName = contentDisposition.match(/filename="(.+)"/)[1];

            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);

            if (isForPreview) {
                let windows = window.open(URL.createObjectURL(response.data));
                setTimeout(function() {
                    windows.document.title = fileName;
                    windows.focus();
                }, 300);
                return true;
            }

            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            return true;
        },
        ...mapActions('planogram', ['toggleLoader']),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/override_pricebook/download-planogram.js